export var OSTypeEnum;
(function (OSTypeEnum) {
    OSTypeEnum["Windows"] = "Windows";
    OSTypeEnum["macOS"] = "macOS";
    OSTypeEnum["Linux"] = "Linux";
    OSTypeEnum["Android"] = "Android";
    OSTypeEnum["iOS"] = "iOS";
    OSTypeEnum["Unknown"] = "Unknown";
})(OSTypeEnum || (OSTypeEnum = {}));
/**
 * Определяет операционную систему пользователя на основе User-Agent.
 * @returns {OSType}
 */
export const getOS = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Windows NT')) {
        return OSTypeEnum.Windows;
    }
    if (userAgent.includes('Mac OS X')) {
        return OSTypeEnum.macOS;
    }
    if (userAgent.includes('Linux') && !userAgent.includes('Android')) {
        return OSTypeEnum.Linux;
    }
    if (userAgent.includes('Android')) {
        return OSTypeEnum.Android;
    }
    if (userAgent.includes('iPhone') || userAgent.includes('iPad') || userAgent.includes('iPod')) {
        return OSTypeEnum.iOS;
    }
    return OSTypeEnum.Unknown;
};
